"use strict";
/*
 * © 2025 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeWrapper = void 0;
const styled_components_1 = __importDefault(require("../styled-components"));
exports.NodeWrapper = styled_components_1.default.div `
  position: relative;
  box-shadow: 0 2px 0 0 ${(props) => (props.isOver ? props.theme.fg : "#0000")};
  display: flex;
  background: ${(props) => (props.multiSelected ? "#7dc2ff44" : "#fff1")};
  padding: 5px;
  margin-bottom: 5px;
  border-radius: ${(props) => props.theme.radius};
  text-align: left;
  word-break: break-word;
  cursor: ${(props) => (props.noPointer ? "initial" : "pointer")};
  width: 100%;
  height: 30px;
  overflow: hidden;
  padding-left: 10px;
`;
//# sourceMappingURL=style.js.map